import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _AnimatedStaticCoinRi;
import { memo, useEffect, useRef, useState } from 'react';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import cn from 'clsx';
import { AnimatedStaticCoinRive } from "../AnimatedStaticCoinRive";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlayroomRewardBanner = function PlayroomRewardBanner(_ref) {
  var dataTestIid = _ref['data-testid'],
    withRiveCoin = _ref.withRiveCoin,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Introduce un texto' : _ref$text,
    open = _ref.open,
    isDark = _ref.isDark,
    animated = _ref.animated,
    hideClose = _ref.hideClose,
    button = _ref.button,
    onClose = _ref.onClose;
  var bannerRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  useEffect(function () {
    if (bannerRef.current) {
      setHeight(bannerRef.current.clientHeight);
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: cn('tw-relative',
    // Margins
    'tw-mx-2 sm:tw-mx-3.2',
    //Animation transition duration
    animated ? 'tw-duration-1000' : 'tw-duration-0', 'tw-ease-[cubic-bezier(0.4, 0, 0.2, 1)]',
    // Show and hide banner
    open ? 'tw-mt-1.2 sm:tw-mt-1.6' : 'tw-h-0 tw-mt-0'),
    style: {
      height: open && height !== 0 ? height : undefined,
      transitionProperty: 'height'
    },
    "data-testid": dataTestIid,
    children: /*#__PURE__*/_jsx("div", {
      ref: bannerRef,
      className: cn(
      // Banner Containner
      // Position
      'tw-absolute tw-bottom-0 tw-right-0 tw-left-0',
      // Paddings
      'tw-px-1.6 tw-py-1.2 md:tw-px-2.4',
      // Borders
      'tw-rounded-1 tw-border tw-border-solid tw-border-warning-400',
      // Backgrounds
      'tw-bg-warning-100 dark:tw-bg-elevation-dark-03'),
      children: /*#__PURE__*/_jsxs("div", {
        className: cn(
        // Banner Content
        // Flex
        'tw-flex tw-items-center tw-w-full tw-flex-col sm:tw-flex-row tw-justify-between tw-text-center sm:tw-text-left'),
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tw-w-full tw-flex sm:tw-items-center",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "tw-flex tw-items-center tw-flex-grow",
            children: [withRiveCoin && (_AnimatedStaticCoinRi || (_AnimatedStaticCoinRi = /*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
              className: "tw-mr-1.2 tw-self-start"
            }))), /*#__PURE__*/_jsx("p", {
              className: cn(
              // Color
              'tw-text-warning-500 dark:tw-text-warning-400',
              // Font
              'tw-text-left tw-font-subtitle5'),
              children: text
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "tw-flex tw-justify-end tw-items-center tw-h-full",
            children: [button && /*#__PURE__*/_jsx("button", {
              type: "button",
              className: cn(
              // Display
              'tw-hidden', 'sm:tw-block',
              // Base styles btn
              {
                'tw-btn-inverse-xs tw-btn-white': isDark
              }, {
                'tw-btn-inverse-xs': !isDark
              },
              // Height
              'tw-min-h-0',
              // Margin
              'tw-mr-2.4'),
              onClick: button === null || button === void 0 ? void 0 : button.onClick,
              children: button === null || button === void 0 ? void 0 : button.label
            }), !hideClose && /*#__PURE__*/_jsx("button", {
              type: "button",
              onClick: onClose,
              className: "tw-flex-shrink tw-self-start sm:tw-self-center",
              "data-testid": "close-reward-banner-button",
              children: /*#__PURE__*/_jsx(CloseSmall, {
                className: cn('sm:tw-block tw-flex-shrink-0',
                // Close colors
                'tw-fill-current tw-text-primary-light-600 dark:tw-text-neutral-dark-400'),
                size: 24
              })
            })]
          })]
        }), button && /*#__PURE__*/_jsx("button", {
          type: "button",
          className: cn(
          // Display
          'sm:tw-hidden', 'tw-block',
          // Base styles btn
          {
            'tw-btn-inverse-xs tw-btn-white': isDark
          }, {
            'tw-btn-inverse-xs': !isDark
          },
          // Height
          'tw-min-h-0',
          // Margin
          'tw-mt-1.2'),
          onClick: button === null || button === void 0 ? void 0 : button.onClick,
          children: button === null || button === void 0 ? void 0 : button.label
        })]
      })
    })
  }, "PlayroomRewardBanner");
};
export default /*#__PURE__*/memo(PlayroomRewardBanner);